module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_10_28_politics_fbi-reviewing-new-emails-in-clinton-probe-director-tells-senate-judiciary-committee_index.html_plot.b45181b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_10_28_politics_fbi-reviewing-new-emails-in-clinton-probe-director-tells-senate-judiciary-committee_index.html_plot.png
// module id = 381
// module chunks = 0